import { pxToRem, pxTovW } from '@geneo2-web/shared-ui';
import { Box, Skeleton } from '@mui/material';
import { width } from '@mui/system';

const styles = {
  questionDetailsWrapper: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    marginBottom: {
      xs: pxToRem(15),
      md: pxTovW(15),
    },
  },
  marksWrapper: {
    width: '100%',
    // padding: {
    //   xs: `${pxToRem(5)} ${pxToRem(13)}`,
    //   md: `${pxTovW(7)} ${pxTovW(11)}`,
    // },
    borderRadius: {
      xs: pxToRem(16),
      md: pxTovW(35),
    },
    border: '1px solid #CEEAFF',
    marginLeft: '10px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: pxToRem(60),
  },
};

export default function QuestionContainerShimmer() {
  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={styles.questionDetailsWrapper}>
        <Box sx={{ marginLeft: 'auto' }}>
          <Box sx={styles.marksWrapper}>
            <Skeleton variant="text" width={pxToRem(40)} height={pxToRem(20)} />
          </Box>
        </Box>
      </Box>
      <Skeleton
        variant="rectangular"
        width="100%"
        height={pxToRem(120)}
        sx={{ borderRadius: pxToRem(10), mb: pxToRem(20) }}
      />
    </Box>
  );
}
